import React from "react";
import Navbar2 from "../mainnav";
import Footer from "../Footer";
import { Container, Row, Col } from "react-bootstrap";
import "../../Home_css/privacy_policy.css";

const PrivacyPolicy = () => {
  return (
    <>
      <Navbar2 />

      <section className="PrivacyPolicy">
        <Container className="mt-5">
          <h1 className="text-uppercase text-gray-800 mb-3">Privacy Policy</h1>

          <div className="custom-margin-top">
            <Row>
            <p>
                  This privacy policy sets out how “Dahlia” uses and protects any information that you give when you use this website.
                  Dahlia is committed to ensuring your privacy is protected. Should we ask you to provide certain information by which
                  you can be identified, it will only be used in accordance with this privacy statement.
                </p>
              <Col md={6}>
               

                <h5>We may collect the following information:</h5>
                <ul>
                  <li>Name and job title</li>
                  <li>Contact information including email address</li>
                  <li>Demographic information such as postcode, preferences and interests</li>
                  <li>Other information relevant to customer surveys and/or offers</li>
                </ul>
             
                <p><strong>Uses of this information include:</strong></p>
                <ul>
                  <li>Internal record keeping</li>
                  <li>Improving our products and services</li>
                  <li>Sending promotional emails and offers</li>
                  <li>Market research via email, phone, fax, or mail</li>
                  <li>Customizing the website according to your interests</li>
                  <li>Marketing through third-party partners (with consent)</li>
                </ul>

                <p>We will never sell your information.</p>

                <h5>Security</h5>
                <p>
                  We are committed to ensuring your information is secure. To prevent unauthorized access, we’ve implemented suitable physical,
                  electronic, and managerial procedures.
                </p>

                
              </Col>

              <Col md={6}>
              <h5>How we use cookies</h5>
                <p>
                  A cookie is a small file which asks permission to be placed on your device. Cookies help analyze web traffic and allow
                  web apps to respond to you as an individual. They don’t give us access to your device or personal data beyond what you choose to share.
                </p>
                <p>
                  We use traffic log cookies to identify which pages are used. This helps us analyze data and improve the site. The data is
                  used only for statistical analysis, then removed from the system.
                </p>

                <p>
                  You can choose to accept or decline cookies in your browser settings. Declining may limit full use of the site.
                </p>

                <h5>Links to Other Websites</h5>
                <p>
                  Our website may contain links to other websites. Once you leave our site, we are not responsible for the protection or privacy
                  of your data on those websites.
                </p>

                <h5>Controlling Your Personal Information</h5>
                <ul>
                  <li>Use opt-out checkboxes on forms</li>
                  <li>Contact us at <a href="mailto:Info@dahliahealth.com">Info@dahliahealth.com</a> to opt out</li>
                  <li>
                    You can request details of data we hold about you under the Data Protection Act 1998 (a small fee may apply).
                  </li>
                  <li>
                    If your information is incorrect, please email us. We’ll correct it promptly.
                  </li>
                </ul>
              </Col>
            </Row>
          </div>
        </Container>
      </section>

      <Footer />
    </>
  );
};

export default PrivacyPolicy;
